<template>
	<div class="tabs-layout stats">
		<md-tabs @md-changed="changeTab" md-active-tab="statistiques" class="w-full">
			<md-tab id="general" md-label="Général" md-disabled></md-tab>
			<md-tab id="statistiques" :md-label="tabs[0].label">
				<statistiques-global v-if="tabs[0].active" :active="tabs[0].active"></statistiques-global>
			</md-tab>
			<md-tab id="planning" md-label="Planification" md-disabled></md-tab>
			<md-tab id="without-contract" :md-label="tabs[1].label">
				<intervention-without-contract v-if="tabs[1].active" :active="tabs[1].active"></intervention-without-contract>
			</md-tab>
			<md-tab id="poorly-planned" :md-label="tabs[2].label">
				<interventions-poorly-planned v-if="tabs[2].active" :active="tabs[2].active"></interventions-poorly-planned>
			</md-tab>
		</md-tabs>
	</div>
</template>

<script>
import StatistiquesGlobal from "./general/StatistiquesGlobal";
import InterventionWithoutContract from "./planning/InterventionWithoutContract";
import InterventionsPoorlyPlanned from "./planning/InterventionsPoorlyPlanned";

export default {
    name: "Stats",
	components: { StatistiquesGlobal, InterventionWithoutContract, InterventionsPoorlyPlanned },
	data() {
		return {
			tabs: [
				{ id: 'statistiques', label: 'Statistiques', active: true },
				{ id: 'without-contract', label: 'Inter sans contrat actif', active: false },
				{ id: 'poorly-planned', label: 'Inter mal planifiées', active: false },
			],
		}
	},
	methods: {
		changeTab(id = 'statistiques') {
			this.tabs.map(tab => tab.active = false)
			let activeTab = this.tabs.find(tab => tab.id === id)
			if(activeTab) activeTab.active = true
		}
	},
}
</script>

<style scoped lang="scss">

</style>
